<template>
  <div class="freelance-projects dashboard">
    <div class="greeting">
      <div class="container greeting-content px-5">
        <h5>Hi Mary 🧕</h5>
        <p>Choose a Program to get started</p>
      </div>
    </div>
    <div class="container" style="max-width: 1140px !important">
      <div class="programs-card">
        <programsCard />
      </div>
      <br />
      <br />
    </div>
  </div>
</template>

<script>
import programsCard from "./components/programsCard";

export default {
  components: {
    programsCard,
  },
  data() {
    return {
      timeOfTheDay: "",
    };
  },
  methods: {
    greeting() {
      var time = new Date().getHours();
      if (time < 10) {
        this.timeOfTheDay = "Good morning";
      } else if (time < 20) {
        this.timeOfTheDay = "Good day";
      } else {
        this.timeOfTheDay = "Good evening";
      }
    },
  },
  computed() {},
  mounted() {
    this.greeting();
  },
};
</script>